module.exports = __webpack_public_path__ + "img/Marcas-propias.3669d1e6.png";